// Error Page
import Error404 from '@/components/Error404.vue';

export default [
  {
    path: '*',
    component: Error404
  },
]
